import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectWorkingProjectUuid } from '@/store/slices/project/selectors';
import { selectLoadingScheduledEmails, selectScheduledEmails } from '@/store/slices/scheduled-emails/selectors';
import { loadEventScheduledEmails } from '@/store/slices/scheduled-emails';
import { loadFavoriteTemplates, loadRecentTemplates } from '@/store/slices/campaigns';

const useLoadCampaigns = () => {
  const dispatch = useAppDispatch();
  const projectUuid = useAppSelector(selectWorkingProjectUuid);
  const loadingEmails = useAppSelector(selectLoadingScheduledEmails);
  const scheduledEmails = useAppSelector(selectScheduledEmails);

  useEffect(() => {
    if (projectUuid && !loadingEmails && !scheduledEmails) {
      dispatch(loadEventScheduledEmails(projectUuid));
      dispatch(loadFavoriteTemplates());
      dispatch(loadRecentTemplates());
    }
  }, [dispatch, projectUuid, loadingEmails, scheduledEmails]);
};

export default useLoadCampaigns;
